import React, { useEffect, useState } from "react";

const Inventory = ({ active }) => {
  return (
    <svg
      className="w-6 h-6"
      viewBox="0 0 29 20"
      xmlns="http://www.w3.org/2000/svg"
      fill={active ? "#BA004F" : "#C1A4A4"}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.46045 -0.000183105H9.79057C10.5222 -0.000183105 11.3759 0.447143 11.7199 1.02891L12.8852 3.00002H23.5003C24.3288 3.00002 25.0003 3.6712 25.0003 4.50033V6.99967H26.0004H27.0005C27.1826 6.99967 27.3533 7.04836 27.5004 7.13344C27.6475 7.04836 27.8182 6.99967 28.0004 6.99967C28.5527 6.99967 29.0005 7.44737 29.0005 7.99948V12.9997C29.0005 13.5518 28.5527 13.9995 28.0004 13.9995C27.448 13.9995 27.0005 13.5518 27.0005 12.9997L27.0005 8.99969H25.0003L6.00032 8.99969V16.4996V17.9999V18.9997C6.00032 19.5519 5.55255 19.9996 5.00049 19.9996H4.00039H3.50047H2.00046H1.50077C0.672045 19.9996 0 19.328 0 18.5V6.48262V4.50033V1.09286C0 0.473719 0.656634 -0.000183105 1.46045 -0.000183105ZM4.00039 16.9997V16.4996V6.99967H9.00035H10.0005H23.0004V5.00004H13.5292L13.5004 4.99965C11.9978 4.98849 11.5005 3.99984 11.5005 3.99984L10.0005 1.99984H9.00035H2.00046V3.99984V6.99967V16.9997C2.00046 17.5518 2.44797 17.9999 3.00029 17.9999C3.55262 17.9999 4.00039 17.5518 4.00039 16.9997Z"
      />
    </svg>
  );
};

export default Inventory;
